import cn from 'classnames';
import styles from './header-image.module.css';

function HeaderImage({
  url,
  topBgImage,
  backgroundColor,
  children,
  maxHeight = { xs: 'initial' },
  height = { xs: 'auto' },
  position = 'center',
  size = 'cover',
  repeat = 'no-repeat'
}) {
  const bgImageStyle =
    topBgImage && url
      ? `${topBgImage}, url(${url})`
      : topBgImage
        ? topBgImage
        : url
          ? `url(${url})`
          : undefined;

  const varStyle = {
    ...(backgroundColor ? { backgroundColor } : {}),
    ...(bgImageStyle ? { backgroundImage: bgImageStyle } : {}),
    '--header-mh-xs': maxHeight.xs || undefined,
    '--header-h-xs': height.xs || undefined,
    '--header-mh-sm': maxHeight.sm || undefined,
    '--header-h-sm': height.sm || undefined,
    '--header-mh-md': maxHeight.md || undefined,
    '--header-h-md': height.md || undefined,
    '--header-mh-lg': maxHeight.lg || undefined,
    '--header-h-lg': height.lg || undefined,
    '--header-mh-xl': maxHeight.xl || undefined,
    '--header-h-xl': height.xl || undefined
  };

  return (
    <header
      className={cn(
        styles.root,
        `snf-bg-position-${position}`,
        `snf-bg-size-${size}`,
        `snf-bg-repeat-${repeat}`
      )}
      style={varStyle}
    >
      {children}
    </header>
  );
}

HeaderImage.displayName = 'HeaderImage';
export { HeaderImage };
